// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"UyyR9PK-zVXI2inX-URaJ","userAuthenticationContent":"_2HyLvVvDkHir-Alumaj5wR","title":"_1_Tyosjyd8wZ622xPQelMf","tabsWrapper":"_1-8UCL8AM0l952dwk7U4hy","tabs":"_1MvHklIFoj1Ekrx6HP96cd","logo":"_14L0vlC-PJ3eTEDS8wmJHU"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/UserAuthenticationPage/UserAuthenticationPage.scss
// module id = 1837
// module chunks = 0